import { FunctionComponent, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import { FeedCardLoader, useAppSelector, useEventDiscussionFeed } from '../../../';
import { EventDiscussionCard } from './EventDiscussionCard';

import classes from './EventDiscussionFeed.module.scss';

interface EventDiscussionFeedProps {
  eventId: number;
  scrollableTarget?: string;
}

export const EventDiscussionFeed: FunctionComponent<EventDiscussionFeedProps> = memo(
  ({ eventId, scrollableTarget }) => {
    const { t: ctxT } = useTranslation('', { keyPrefix: 'eventDetails' });

    const { loadMoreEventDiscussionFeedItems } = useEventDiscussionFeed(eventId);

    const { eventDiscussionFeed, hasNextPage, isFetched } = useAppSelector(
      ({ eventDiscussionFeed }) => eventDiscussionFeed
    );

    const dataLength = useMemo(() => eventDiscussionFeed.length, [eventDiscussionFeed.length]);

    if (!isFetched) {
      return <Skeleton height={'3rem'} />;
    }

    if (!dataLength) {
      return <div className={classes['event-discussion-feed__empty']}>{ctxT('no-discussion')}</div>;
    }

    return (
      <InfiniteScroll
        next={loadMoreEventDiscussionFeedItems}
        hasMore={hasNextPage}
        dataLength={dataLength}
        loader={<FeedCardLoader />}
        scrollableTarget={scrollableTarget}
      >
        <div className={classes['event-discussion-feed']}>
          {eventDiscussionFeed.map((card) => (
            <EventDiscussionCard key={card.id} card={card} />
          ))}
        </div>
      </InfiniteScroll>
    );
  }
);
